import { render } from "./ReferralPatientForm.vue?vue&type=template&id=5aaff8e9&scoped=true"
import script from "./ReferralPatientForm.vue?vue&type=script&lang=js"
export * from "./ReferralPatientForm.vue?vue&type=script&lang=js"

import "./ReferralPatientForm.vue?vue&type=style&index=0&id=5aaff8e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaff8e9"]])

export default __exports__